// extracted by mini-css-extract-plugin
module.exports = {"root":"ScreenContainer_root"};